import { Span } from '@vp/swan';
import { RangeTuple } from '../../../types/Search';

interface HighlightedTextProps {
    text: string;
    indices: readonly RangeTuple[];
}

export const HighlightedText = ({ text, indices }: HighlightedTextProps) => {
    const parts = [];
    let lastIndex = 0;

    indices.forEach(([start, end], index) => {
        if (start > lastIndex) {
            parts.push(<Span key={`text-${index}`}>{text.slice(lastIndex, start)}</Span>);
        }
        parts.push(<strong key={`highlight-${index}`}>{text.slice(start, end + 1)}</strong>);
        lastIndex = end + 1;
    });

    if (lastIndex < text.length) {
        parts.push(<Span key={`text-end`}>{text.slice(lastIndex)}</Span>);
    }

    return <Span>{parts}</Span>;
};
